import Button from '@material-ui/core/Button'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import MenuItem from '@material-ui/core/MenuItem'
import MenuList from '@material-ui/core/MenuList'
import Paper from '@material-ui/core/Paper'
import Popper from '@material-ui/core/Popper'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import React, { useRef, useState } from 'react'
import 'src/assets/css/components/splitButton.css'
import Spinner from 'src/components/Spinner'
import ISplitButtonProps from 'src/models/components/ISplitButtonProps'

const SplitButton = (props: ISplitButtonProps): JSX.Element => {

    const [open, setOpen] = useState(false)
    const [selected, setSelected] = useState(0)

    const anchorRef = useRef<HTMLDivElement>(null)

    const handleToggle = () => setOpen(o => !o)
    const handleClose = () => setOpen(false)

    const { label, icon, options, onClick, SpinnerProps, style } = { ...props, ...props.options[selected] }
    const { disabled: isOptionDisabled, title } = props.options[selected]
    const described = options.some(option => option.description)

    return <>
        <ButtonGroup
            style={style}
            variant='contained'
            color='primary'
            disableElevation
            disabled={props.disabled}
            title={title}
            ref={anchorRef}>
            <Button
                disabled={isOptionDisabled}
                startIcon={icon}
                onClick={onClick}>
                {label}
            </Button>
            <Button
                size='small'
                onClick={handleToggle}
                aria-label='more-options'>
                <Spinner {...SpinnerProps}><ArrowDropDownIcon /></Spinner>
            </Button>
        </ButtonGroup>
        <Popper
            open={open}
            anchorEl={anchorRef.current}
            placement='bottom-end'>
            <Paper className={described ? 'split-button-menu described' : 'split-button-menu'}>
                <ClickAwayListener onClickAway={handleClose}>
                    <div>
                        {described && props.menuHeader &&
                            <p className='split-button-menu-header'>{props.menuHeader}</p>}
                        <MenuList id="split-button-menu">
                            {options.map((option, i) => {
                                if (!described && i === selected) return

                                const onClick = () => {
                                    setSelected(i)
                                    handleClose()
                                    // a described menu says what each option does, so choosing one does it
                                    described && option.onClick()
                                }

                                // a disabled item takes no pointer events, which would hide its title
                                const itemProps = {
                                    disabled: option.disabled,
                                    title: option.title,
                                    style: option.disabled ? { pointerEvents: 'auto' as const } : undefined,
                                    onClick: option.disabled ? undefined : onClick,
                                }

                                if (!described)
                                    return <MenuItem key={i} {...itemProps}>{option.label}</MenuItem>

                                return <MenuItem key={i} selected={i === selected} {...itemProps} className='split-button-option'>
                                    {option.menuIcon}
                                    <span className='split-button-option-text'>
                                        <span className='split-button-option-title'>
                                            <span>{option.label}</span>
                                            {option.chip}
                                        </span>
                                        <span className='split-button-option-description'>{option.description}</span>
                                        {option.example && <span className='split-button-option-example'>{option.example}</span>}
                                    </span>
                                </MenuItem>
                            })}
                        </MenuList>
                    </div>
                </ClickAwayListener>
            </Paper>
        </Popper>
    </>
}

export default SplitButton
